define('speedmaster_warranty_cart_summary.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('speedmaster_warranty_cart_summary', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "   ";
},"useData":true}, 'extensions/Speedmaster/SpeedmasterWarranty/2.0.0/', 'extensions/Speedmaster/SpeedmasterWarranty/2.0.0/', Handlebars);
});